import { CONFIRM_COLOR, CONFIRM_ICONS, TYPE_MODAL } from '../modal-confirm-notification';

export const CANCEL_PAY = {
    typeModal: TYPE_MODAL.NOTIFICATION,
    title: '¿Está seguro que desea cancelar la venta?',
    valueButton: 'Sí',
    color: CONFIRM_COLOR.WARN,
    icon: CONFIRM_ICONS.WARNING
  };
